import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

function FeesInformation({ data }) {
  return (
    <div className="p-3">
      <table className="transaction-table table table-striped table-borderless table-sm">
        <tbody>
          {data.find(item => get(item, 'attributes.description') === "ZONING FEE") && (
            <>
              <tr className="bg-white">
                <th className="py-3 cms-text-primary bg-white text-lg">
                  <b>ZONING FEE</b>
                </th>
              </tr>
              <tr>
                <td className="text-dark font-weight-bold" width="150">
                  {get(data.find(item => get(item, 'attributes.description') === "ZONING FEE"), 'attributes.description')}
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td className="text-dark">
                  <b>&#8369; {get(data.find(item => get(item, 'attributes.description') === "ZONING FEE"), 'attributes.amount_human') || "-"}</b>
                </td>
              </tr>
            </>
          )}
          {data.length > 1 && (
            <>
              <tr className="bg-white">
                <th className="py-3 cms-text-primary bg-white text-lg">
                  <b>ANNUAL INSPECTION FEE</b>
                </th>
              </tr>
              {data.map(item => get(item, 'attributes.description') !== "ZONING FEE" && (
                <>
                  <tr>
                    <td className="text-dark font-weight-bold" width="50%">
                      {get(item, 'attributes.description')}
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td className="text-dark">
                      <b>&#8369; {get(item, 'attributes.amount_human') || "-"}</b>
                    </td>
                  </tr>
                </>
              ))}
            </>
          )}

        </tbody>
      </table>
    </div>
  );
}

FeesInformation.defaultProps = {
}

FeesInformation.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
};

export default FeesInformation;
